/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { trainingServices } from '../../../../api/services/trainingServices';
import { setMyTrainingData } from '../../../../infra/aggregates/myProfile/TrainingAggregates/getMyTrainingSlice';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

interface PropsValues {
  setMytrainingDatas: (data: any) => void;
  textFilter: any;
}

function DTOMytraining({ setMytrainingDatas, textFilter }: PropsValues) {
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();

  async function getMyTrainingList(companyId: number, emp_id: number) {
    const response: any = await trainingServices.getMyTrainingData(
      companyId,
      emp_id,
    );
    if (response.response == 'success') {
      dispatch(setMyTrainingData(response.data));
      const mytrainingDataList: any = _.map(response.data, (data: any) => {
        //score

        let status: any = 'Scheduled';
        if (data?.status == 3) {
          if (data?.evaluation_status == 0) {
            status = 'Absent';
          } else {
            if (data?.training_type?.min_score > 0) {
              const min_score: any = data?.training_type?.min_score;

              if (min_score) {
                if (data?.score >= min_score) {
                  status = 'Passed';
                } else {
                  status = 'Failed';
                }
              }
            } else {
              status = 'Completed';
            }
          }
        } else if (data?.status == 4) {
          status = 'Canceled';
        }

        const rowData: any = {
          id: data?.id,
          trainingtype: data?.training_type ? data?.training_type?.name : '--',
          trainer: data?.trainer
            ? data?.trainer?.first_name + ' ' + data?.trainer?.last_name
            : t('External'),
          avatar: data?.trainer ? data?.trainer?.profile_pic : '',
          startdate: data?.start_date ?? '--',
          enddate: data?.end_date ?? '--',
          starttime: data?.start_time ?? '--',
          endtime: data?.end_time ?? '--',
          score: data?.score ? data?.score : 0,
          status: status,
          timezone: {
            timezone: data?.timezone,
            offset: data?.timezoneOffset,
          },
        };
        return rowData;
      });

      if (textFilter.length) {
        const txt = textFilter.toLowerCase();
        const filteredData = _.filter(mytrainingDataList, function (e) {
          return e?.training_type?.name.toLowerCase().includes(txt);
        });
        setMytrainingDatas(filteredData);
      } else {
        setMytrainingDatas(mytrainingDataList);
      }
    }
  }
  useEffect(() => {
    if (selector.company_id && selector.emp_id)
      getMyTrainingList(selector.company_id, selector.emp_id);
  }, []);
  return <></>;
}
export default DTOMytraining;
